import React from "react";
import clsx from 'clsx';
import { StyledAppIcon } from "./index.styled";
type IconProps = {
  src: string;
  alt?: string;
  className?: string;
  onClick?: () => void;
};

const Icon: React.FC<IconProps> = ({
  src,
  alt,
  className,
  onClick,
  ...rest
}: IconProps) => (
  <StyledAppIcon
    className={clsx({ [`${className}`]: !!className }, "img-icon")}
    onClick={onClick}
    {...rest}
  >
    <img src={src} alt={alt || "Icon"} />
  </StyledAppIcon>
);
export default Icon;
